import { create } from 'zustand';

interface LoadingModalState {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const useLoadingModal = create<LoadingModalState>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set(() => ({ loading })),
}));

export default useLoadingModal;
